import { transform, isEqual, isObject } from 'lodash';

const changes = (object, base) => (
  transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      // eslint-disable-next-line no-param-reassign
      result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
    }
  })
);

const objectDiff = (object, base) => changes(object, base);

export default objectDiff;



// WEBPACK FOOTER //
// ./src/utils/objectDiff.js